import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobReasons'
import Component from 'components/JobReasons'

export default createListViewContainer({ actions, selectors: selectors.jobReasons })(Component)
